var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3184",
    "data-name": "Rectangle 3184",
    width: 16,
    height: 16,
    transform: "translate(1217 411)",
    fill: "#8a8a8a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3185",
    "data-name": "Rectangle 3185",
    width: 16,
    height: 16,
    transform: "translate(1003 919)",
    fill: "#8a8a8a",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attachIcon",
    transform: "translate(-1217 -411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_129",
    "data-name": "Mask Group 129",
    transform: "translate(214 -508)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M17.143,5.714V14.1a3.048,3.048,0,0,1-6.1,0V5.333a1.9,1.9,0,1,1,3.81,0V14.1a.762.762,0,0,1-1.524,0V6.857H12.19V14.1a1.9,1.9,0,0,0,3.81,0V5.333a3.048,3.048,0,0,0-6.1,0V14.1a4.19,4.19,0,1,0,8.381,0V5.714Z",
    transform: "translate(996.905 916.714)",
    fill: "#8a8a8a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachIcon);
export default __webpack_public_path__ + "static/media/attachIcon.dc4281f0f3861871743a68444b4c6dda.svg";
export { ForwardRef as ReactComponent };